var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"duplicate-recharge-confirm-host"})
}
var staticRenderFns = []

export { render, staticRenderFns }